import React from "react";

export default function Clip({ size }: { size: number }) {
    return (
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 0.5C0.947715 0.5 0.5 0.947715 0.5 1.5V14.5C0.5 15.0523 0.947715 15.5 1.5 15.5H14.5C15.0523 15.5 15.5 15.0523 15.5 14.5V1.5C15.5 0.947715 15.0523 0.5 14.5 0.5H1.5ZM2 14.5C1.72386 14.5 1.5 14.2761 1.5 14V2C1.5 1.72386 1.72386 1.5 2 1.5H14C14.2761 1.5 14.5 1.72386 14.5 2V14C14.5 14.2761 14.2761 14.5 14 14.5H2Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 11.6451C4.5 12.0275 4.91183 12.2683 5.24513 12.0809L11.7253 8.43579C12.0651 8.24464 12.0651 7.75536 11.7253 7.56421L5.24513 3.91914C4.91183 3.73165 4.5 3.97251 4.5 4.35492V11.6451Z" fill="white" />
        </svg>)
}

